function wrapEvent(theirHandler, ourHandler) {
    return (event)=>{
        if (theirHandler) theirHandler(event);
        if (!event.defaultPrevented) return ourHandler(event);
    };
}
export default wrapEvent;
